export default __webpack_public_path__ + "static/media/14_gaming.78200b5e.png";